import React from 'react';
import PropTypes from 'prop-types';

import './CopiedToastMessage.scss';

function CopiedToastMessage({ message = 'Copied' }) {
  return (
    <div className="full-text-success-toast-message__content">
      <span className="full-text-success-toast-message__content_icon ">
        <svg className="els-btn-icon">
          <use xlinkHref="#icon-check" />
        </svg>
      </span>
      {message}
    </div>
  );
}

CopiedToastMessage.propTypes = {
  message: PropTypes.string,
};

export default CopiedToastMessage;
